/*
 * @Author: 吴文洁
 * @Date: 2019-09-12 11:28:19
 * @LastEditors: renmanyi
 * @LastEditTime: 2023-11-17 11:46:23
 * @Description:
 */
import Vue from 'vue';
import Router from 'vue-router';
import User from '../core/user';
import Platform from '../core/platform';
import LeaveRouter from './Leave';
import InstRouter from './Inst';
import HomeworkRouter from './Homework';
import Mine from './Mine';
import Comment from './Comment';
import Benefit from './Benefit';
import Renew from './Renew';
import Mall from './Mall';
import Share from './Share';
import Order from './Orders';
import WechatRouter from './WechatRouter';
import Transcript from './Transcript';
import Album from './Album';
import Live from './live';
import Video from './video';
import Series from './Series';
import Growth from './growth';
import Poster from './Poster';
import Download from './Download';
import Webview from './Webview';
import Test from './Test';
import AIEnroll from './AIEnroll';
import TeachingTraining from './teachingTraining';
import ArtGallery from './ArtGallery';
import ArtExhibition from './ArtExhibition';
import Local from './Local';
import Testpdf from './Testpdf';

import Grade from './Grade';
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);
let routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/module/home/HomePage.vue'),
    meta: {
      title: 'appname',
      keepAlive: true,
      logined: true,
    },
  },
  {
    path: '/zfblogin',
    name: 'zfblogin',
    component: () => import('@/module/login/ZFBLoginPage.vue'),
    meta: {
      title: 'appname',
      keepAlive: false,
      logined: false,
      notBrowser: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/module/login/LoginPage.vue'),
    meta: {
      title: 'appname',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/check/phone',
    name: 'check_phone',
    component: () => import('@/module/login/CheckPhonePage.vue'),
    meta: {
      title: '关联学员',
      keepAlive: false,
      logined: true,
    },
  },
  {
    path: '/no/student',
    name: 'no_student',
    component: () => import('@/module/login/NoStudentPage.vue'),
    meta: {
      title: '小麦校讯通',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/add/student',
    name: 'add_student',
    component: () => import('@/module/login/AddStudentPage.vue'),
    meta: {
      title: '添加学员',
      keepAlive: false,
      logined: true,
    },
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('@/components/VideoModal.vue'),
    meta: {
      title: '视频播放',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/audio',
    name: 'audio',
    component: () => import('@/components/AudioModal.vue'),
    meta: {
      title: '音频播放',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/module/home/HomePage.vue'),
    meta: {
      title: 'appname',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/home/:tab',
    name: 'home_tab',
    component: () => import('@/module/home/HomePage.vue'),
    meta: {
      title: 'appname',
      keepAlive: false,
      logined: true,
    },
  },
  {
    path: '/mine/course/schedule',
    name: 'mine_course_schedule',
    component: () => import('@/module/mine/MineCourseSchedulePage.vue'),
    meta: {
      title: '课程表',
      keepAlive: false,
      logined: true,
    },
  },
  {
    path: '/mine/course/schedule/v5',
    name: 'mine_course_schedule_v5',
    component: () => import('@/module/mine/v5/MineCourseSchedulePage.vue'),
    meta: {
      title: '课程表',
      keepAlive: false,
      logined: true,
    },
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('@/module/pay/ApplyPay.vue'),
    meta: {
      title: '报名缴费单',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/venuePay',
    name: 'venuePay',
    component: () => import('@/module/pay/VenuePay.vue'),
    meta: {
      title: '场地预订',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/aiFamilyPay',
    name: 'aiFamilyPay',
    component: () => import('@/module/pay/aiFamilyPay.vue'),
    meta: {
      title: 'Ai家教支付',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/card_pay',
    name: 'card_pay',
    component: () => import('@/module/pay/CardPay.vue'),
    meta: {
      title: '办卡缴费',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/web/pay',
    name: 'web_pay',
    component: () => import('@/module/pay/WebPay.vue'),
    meta: {
      title: '报名缴费单',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/scan/pay',
    name: 'scan_pay',
    component: () => import('@/module/pay/ScanPay.vue'),
    meta: {
      title: '报名',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/payment/list',
    name: 'payment_list',
    component: () => import('@/module/pay/paymentList.vue'),
    meta: {
      title: '报名缴费单',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/success/pay',
    name: 'success_pay',
    component: () => import('@/module/pay/successPay.vue'),
    meta: {
      title: '订单详情',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/online/success/pay',
    name: 'online_success_pay',
    component: () => import('@/module/pay/onlineSuccessPay.vue'),
    meta: {
      title: '支付成功',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/online/pay',
    name: 'online_pay',
    component: () => import('@/module/pay/OnlinePay.vue'),
    meta: {
      title: '在线收款',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/xm/pay',
    name: 'xm_pay',
    component: () => import('@/module/pay/XMPay.vue'),
    meta: {
      title: '小麦收银',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/xm/tl/pay',
    name: 'xm_pay_text',
    component: () => import('@/module/pay/XMTLPay.vue'),
    meta: {
      title: '小麦在线收银',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/xm/pre/pay',
    name: 'xm_pre_text',
    component: () => import('@/module/pay/XMPrePay.vue'),
    meta: {
      title: '小麦在线收银',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/punch',
    name: 'punch',
    component: () => import('@/module/punch/XMPunch.vue'),
    meta: {
      title: '快来打卡',
    },
  },
  {
    path: '/xm/active/pay',
    name: 'xm_active_pay',
    component: () => import('@/module/pay/NewYearPay.vue'),
    meta: {
      title: '荣誉奖牌',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/xm/lottery',
    name: 'xm_lottery',
    component: () => import('@/module/pay/Lottery.vue'),
    meta: {
      title: '小麦收银',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/introdution/pay',
    name: 'IntroductionPay',
    component: () => import('@/module/pay/IntroductionPay.vue'),
    meta: {
      title: '小麦收银',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/transfer/index/:id',
    name: 'TransferIndex',
    component: () => import('@/module/transfer/index.vue'),
    meta: {
      title: '邀好友 领奖励',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/transfer/listReward/:referralId/:promoterId',
    name: 'TransferReward',
    component: () => import('@/module/transfer/listReward.vue'),
    meta: {
      title: '获得奖励记录',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/transfer/listProgress/:referralId/:promoterId',
    name: 'TransferProgress',
    component: () => import('@/module/transfer/listProgress.vue'),
    meta: {
      title: '进度记录',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/transfer/posterImage/:imgName',
    name: 'TransferPoster',
    component: () => import('@/module/transfer/posterImage.vue'),
    meta: {
      title: '海报图片',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/system/update',
    name: 'system_update',
    component: () => import('@/module/base/SystemUpdatePage.vue'),
    meta: {
      title: '系统升级中..',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/wechat/default',
    name: 'wechat_default',
    component: () => import('@/module/pay/DefalutPage.vue'),
    meta: {
      title: '提示',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/comment/deleted',
    name: 'comment_deleted',
    component: () => import('@/components/CommentDeleted.vue'),
    meta: {
      title: '提示',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/transfer_school/detail',
    name: 'transfer_school_detail',
    component: () => import('@/module/transferSchool/TransferSchoolDetail.vue'),
    meta: {
      title: '转校详情',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/contract/success',
    name: 'contract_success',
    component: () => import('@/module/contract/ContractPage.vue'),
    meta: {
      title: '签署完成',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/activity/pay',
    name: 'activity/pay',
    component: () => import('@/module/pay/activity.vue'),
    meta: {
      title: '报名缴费单',
      keepAlive: false,
      logined: false,
    },
  },
  {
    path: '/account/pay',
    name: 'account_pay',
    component: () => import('@/module/pay/AccountPay.vue'),
    meta: {
      title: '选择收款方式',
      keepAlive: false,
      logined: false,
    },
  },
];

routes = _.union(
  routes,
  LeaveRouter.routes,
  InstRouter.routes,
  HomeworkRouter.routes,
  Mine.routes,
  Comment.routes,
  Renew.routes,
  Mall.routes,
  Benefit.routes,
  Share.routes,
  Order.routes,
  Transcript.routes,
  Album.routes,
  Live.routes,
  Video.routes,
  Series.routes,
  Growth.routes,
  Poster.routes,
  Download.routes,
  Webview.routes,
  Test.routes,
  Grade.routes,
  AIEnroll.routes,
  TeachingTraining.routes,
  ArtGallery.routes,
  ArtExhibition.routes,
  Local.routes,
  Testpdf.routes,
);

window.router = new Router({
  routes: routes,
});

function loginControl(nextRoute) {
  let fromPointSystem = '';
  if (window.location.href.indexOf('/mine/points') > 0) {
    fromPointSystem = 'true';
  } else {
    fromPointSystem = 'false';
  }
  if (window.location.href.indexOf('/add/stundent') > 0) {
    const isPointSystem = window.getParameterByName('fromPointSystem');
    console.log(isPointSystem);
    if (isPointSystem === 'true') {
      fromPointSystem = 'true';
    } else {
      fromPointSystem = 'false';
    }
  }
  if (
    User.token() &&
    !window.userConfig.hasBindPhone &&
    nextRoute.meta.logined &&
    window.location.hash.indexOf('/wxPanelEntry/jump') == -1 &&
    window.location.href.indexOf('fromBrandMiniapp') == -1 &&
    window.location.href.indexOf('insure') == -1
  ) {
    console.log('跳转登录测试点1');
    window.router.replace({
      name: 'login',
      query: {
        fromPointSystem: fromPointSystem,
      },
    });
    return;
  }

  if (window.location.hash.indexOf('/wxPanelEntry/jump') > 0) {
    if (User.logined() || window.location.hash.indexOf('SEND_REWARD') > 0) {
      //转介绍不需要登录
      WechatRouter.router();
    } else {
      User.loginIn();
    }
  } else if (nextRoute.meta.logined && !User.logined() && Platform.isWeiXin()) {
    User.loginIn();
  }
}

window.router.beforeEach((to, from, next) => {
  if (from.path === '/' && to.path === '/artExhibition') {
    window.showLoading();
  }
  // 拦截非支付宝和微信打开的路由
  if (Platform.isMobile() && to.meta.notBrowser && !Platform.isWeiXin() && !Platform.isAlipay()) {
    window.router.replace({
      name: 'browser_warning',
    });
  }
  next();
});

window.router.afterEach((to, from, next) => {
  console.log('to ---- ');
  console.log(to, from, next);
  console.log('uid', to.query.uid);
  if (to.query.msg) {
    User.setUid(to.query.uid);
  }
  console.log(window.location.href, window.location.href.indexOf('fromBrandMiniapp') != -1);
  if (window.location.href.indexOf('fromBrandMiniapp') != -1) {
    // 判断是从品牌专属小程序过来的
    if (to.query.uid) {
      console.log('miniapp', to.query.uid);
      User.setUid(to.query.uid);
    }
    if (to.query.token) {
      User.setToken(to.query.token);
    }
  }

  loginControl(to);
});

export default window.router;



// WEBPACK FOOTER //
// ./src/router/index.js